import React, { useState, useEffect, useRef } from 'react'
import PropTypes from 'prop-types'
import { graphql } from 'gatsby'

import LogoSVG from './../assets/svg/sub-nav-logo.svg'
import ScrollToTopSVG from './../assets/svg/fat-arrow-up-dark.svg'

const scrollToPosition = (position) => {
  window.scrollTo({
    top: position,
    behavior: 'smooth',
  })
}

const scrollToTop = () => {
  scrollToPosition(0)
}

const SubNavigation = ({ subNav }) => {
  // Initialize state with false so server and client renders match
  const [fixed, setFixed] = useState(false)
  // Initialize reference for nav wrapper element
  const sectionRef = useRef(null)

  useEffect(() => {
    // Handler to call on scroll
    function handleScroll() {
      // Set fixed to true if nav is less than 50px from top
      setFixed(sectionRef.current.getBoundingClientRect().top < 50)
    }

    // Add event listener
    window.addEventListener('scroll', handleScroll)

    // Remove event listener on cleanup
    return () => window.removeEventListener('scroll', handleScroll)
  }, []) // Empty array ensures that effect is only run on mount

  const scrollToElement = (elementId) => {
    const element = document.getElementById(elementId)
    const bodyRect = document.body.getBoundingClientRect().top
    const elementRect = element.getBoundingClientRect().top
    const elementPosition = elementRect - bodyRect

    let offsetPosition = elementPosition - 50

    if (fixed) {
      offsetPosition = elementPosition - 117
    } else {
      offsetPosition = elementPosition - 180
    }

    scrollToPosition(offsetPosition)
  }

  return (
    <section ref={sectionRef}>
      <div className={`c-fNavbarWrapper ${fixed && 'is-fixed'}`}>
        <div className="c-fNavbarHeader">
          <div className="container">
            <div className="row">
              <div className="col-12">
                <LogoSVG />
                <h3 dangerouslySetInnerHTML={{ __html: subNav.header }} />
              </div>
            </div>
          </div>
        </div>
        <nav id="for-navbar" className="c-fNavbar">
          <div className="container">
            <div className="row">
              <div className="col-12">
                <div className="c-fNavbar__menu">
                  <ul className="c-fNavbarMain">
                    <li
                      className="c-gNavbar__toTop"
                      onClick={() => scrollToTop()}
                    >
                      <span className="c-iconContainer" role="button">
                        <ScrollToTopSVG
                          className="c-icon"
                          alt="Fat arrow pointing to links on the page."
                          title="Click here to go back up to the top of the page."
                        />
                      </span>
                    </li>

                    {subNav.links.map((menuItem) => (
                      <li key={`${menuItem.name}_link`}>
                        <span
                          role="button"
                          onClick={() => scrollToElement(menuItem.link)}
                          title={`Click here to view the '${menuItem.name}' section`}
                        >
                          {menuItem.name}
                        </span>
                      </li>
                    ))}
                  </ul>

                  <ul className="c-fNavbarJump">
                    <li className="c-fNavbarJump__text">Jump to:</li>
                    <li className="c-fNavbarJump__link">
                      <span
                        role="button"
                        onClick={() => scrollToElement(`pricing`)}
                        title="Click here to the view the Pricing table and to Sign up"
                      >
                        Pricing &amp; Sign up
                      </span>
                    </li>
                  </ul>
                </div>
              </div>
            </div>
          </div>
        </nav>
      </div>
    </section>
  )
}

SubNavigation.propTypes = {
  subNav: PropTypes.object.isRequired,
}

export default SubNavigation

export const FragmentQuery = graphql`
  fragment SubNavigationFragment on MarkdownRemarkFrontmatter {
    subNav {
      header
      links {
        name
        link
      }
    }
  }
`
